class DorLowestPrice extends HTMLElement {
	connectedCallback() {
		this.abortController = new AbortController();
		this.variantChangeHandler = this.handleVariantChange.bind(this);

		document.addEventListener("variant:change", this.variantChangeHandler);
	}

	disconnectedCallback() {
		document.removeEventListener("variant:change", this.variantChangeHandler);
		this.abortController.abort();
	}

	async handleVariantChange(event) {
		const variant = event.detail?.variant;
		const product = event.detail?.product;

		if (
			!variant ||
			String(product?.id) !== this.dataset.productId ||
			!this.dataset.productUrl ||
			!this.dataset.sectionId
		) {
			return;
		}

		this.abortController.abort();
		this.abortController = new AbortController();

		const url = new URL(this.dataset.productUrl, window.location.origin);
		url.searchParams.set("variant", variant.id);
		url.searchParams.set("section_id", this.dataset.sectionId);

		try {
			const response = await fetch(url, {
				signal: this.abortController.signal,
				headers: {Accept: "text/html"},
			});

			if (!response.ok) {
				throw new Error(`Lowest price request failed: ${response.status}`);
			}

			const html = await response.text();
			const documentFragment = new DOMParser().parseFromString(html, "text/html");
			const updatedElement = documentFragment.querySelector(
				`dor-lowest-price[data-product-id="${CSS.escape(this.dataset.productId)}"]`
			);

			if (updatedElement) {
				this.replaceChildren(...updatedElement.childNodes);
			}
		} catch (error) {
			if (error.name !== "AbortError") {
				console.error(error);
			}
		}
	}
}

if (!window.customElements.get("dor-lowest-price")) {
	window.customElements.define("dor-lowest-price", DorLowestPrice);
}
